<script setup lang="ts">
import { useRouter } from 'vue-router';
import { BRAND_NAME } from '@bill-pulse/shared';
import BrandMark from '@/components/BrandMark.vue';
import { biometryLabel, locked, unlock } from '@/lib/app-lock';
import { useAuthStore } from '@/stores/auth';

/** Écran opaque tant que l'app est verrouillée : rien du contenu ne transparaît. */
const auth = useAuthStore();
const router = useRouter();

async function signOut(): Promise<void> {
  await auth.logout().catch(() => undefined);
  locked.value = false;
  await router.replace('/login');
}
</script>

<template>
  <div v-if="locked" class="safe-top fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-slate-50 px-6 text-center">
    <div class="flex items-center gap-2 text-xl font-bold text-ink"><BrandMark /> {{ BRAND_NAME }}</div>
    <p class="text-sm text-ink-muted">Application verrouillée.</p>
    <button type="button" class="btn-primary w-full max-w-xs" @click="unlock">
      Déverrouiller{{ biometryLabel ? ` avec ${biometryLabel}` : '' }}
    </button>
    <button type="button" class="text-sm text-ink-muted underline" @click="signOut">Se déconnecter</button>
  </div>
</template>
